import React from 'react';
import { useDataContext } from '../context/data';
import translations from '../constants/translations.json';

// Full-screen stop for a venue whose ordering is paused (its heywaitr
// subscription is blocked). Only the heywaitr logo and the guest text —
// no menu, no venue branding, nothing to tap.
export const ORDERING_PAUSED_TEXT = 'The system has been disabled. Log in to the heywaitr admin to reactivate it.';

// The guest's language first: the backend sends one fixed English text.
export const orderingPausedText = (language, message) =>
  translations[language]?.ordering_paused_message || message || ORDERING_PAUSED_TEXT;

const OrderingPausedScreen = ({ message }) => {
  const { language } = useDataContext();

  return (
    <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center px-6 text-center">
      <img src="/heywaitr.b08c1632.jpg" alt="heywaitr" className="h-[40px] w-auto mb-8" />
      <p className="text-lg text-gray-700 max-w-md">{orderingPausedText(language, message)}</p>
    </div>
  );
};

export default OrderingPausedScreen;
